import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useResponsiveStyles } from '@bingads-webui-campaign-react/common-hooks';

const getHeaderStyles = () => ({
  headerContainer: {
    marginBottom: 32,
  },
  stepTitle: {
    fontSize: 26,
    marginBottom: 16,
  },
  stepDescription: {
    lineHeight: '20px',
    fontSize: 14,
  },
});

export const StepHeader = ({
  title,
  description,
}) => {
  const i18n = useContext(I18nContext);
  const getResponsiveStyles = useResponsiveStyles(getHeaderStyles);

  return (
    <div className={classNames(getResponsiveStyles('headerContainer'))}>
      <h1 className={classNames(getResponsiveStyles('stepTitle'))}>
        {i18n.getString(title)}
      </h1>
      <p className={classNames(getResponsiveStyles('stepDescription'))}>
        {i18n.getString(description)}
      </p>
    </div>
  );
};

StepHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
